import React from 'react';
export function Footer() {
  return <footer className="bg-[#0a0a0a] pt-12 pb-8 px-4 border-t border-gold/20" data-id="element-40">
      <div className="max-w-6xl mx-auto flex flex-col items-center text-center" data-id="element-41">
        <img src="https://cdn.magicpatterns.com/uploads/oWPsSuhyfUnKiLy5tYqnnM/logo.png" alt="Axel Cut & Style Studio" className="w-24 h-24 object-contain mx-auto mb-4 mix-blend-lighten" data-id="element-42" />

        <div className="space-y-2 mb-8 font-body text-cream/60 font-light" data-id="element-43">
          <p data-id="element-44">Passaic, NJ</p>
          <p data-id="element-45">
            <a href="tel:8623889571" className="hover:text-gold transition-colors" data-id="element-46">
              862-388-9571
            </a>
          </p>
        </div>

        <div className="w-full h-[1px] bg-white/5 mb-8" data-id="element-47"></div>

        <p className="font-body text-xs text-white/30" data-id="element-48">
          &copy; 2026 Axel Cut & Style Studio. All rights reserved.
        </p>
      </div>
    </footer>;
}